import Modal from "./Modal";

import useBrowser from "../../hooks/useBrowser";

import MatrixItemEditor from "../editors/MatrixItemEditor";

const MatrixItemModal = ({ surveyId, matrixItems, open, onClose, onSave }) => {
  const { windowWidth } = useBrowser();

  return (
    <Modal
      title={"matrixItems"}
      open={open}
      onClose={onClose}
      width="100%"
      height="100%"
    >
      <MatrixItemEditor
        onSave={onSave}
        matrixItems={matrixItems}
        surveyId={surveyId}
      />
    </Modal>
  );
};

export default MatrixItemModal;
